import { defineStore } from 'pinia';
import { useStoreRoot } from '../abstract/root';

export const useStoreSessionTimer = defineStore('SessionTimer', {
  state: () => ({
    timeInSecond: 0,
    intervalID: null as ReturnType<typeof setInterval> | null,
    seconds: '--',
    minutes: '--',
    hours: '--',
  }),
  actions: {
    formatPadStart(n: number) {
      return n > 9 ? '' + n : '0' + n;
    },
    tick() {
      this.timeInSecond++;

      this.seconds = this.formatPadStart(this.timeInSecond % 60);
      this.minutes = this.formatPadStart(Math.floor(this.timeInSecond / 60) % 60);
      this.hours = this.formatPadStart(Math.floor(this.timeInSecond / 3600));
    },
    setSessionTime() {
      localStorage.setItem('session_time', this.timeInSecond.toString());
    },
    start() {
      if (!useStoreRoot().isEstonianLicense || this.intervalID) {
        return;
      }

      const sessionTime = localStorage.getItem('session_time');

      if (sessionTime) {
        this.timeInSecond = Number(sessionTime);
      }

      this.intervalID = setInterval(() => {
        this.tick();
      }, 1000);

      if (process.browser && window) {
        window.addEventListener('beforeunload', this.setSessionTime);
      }
    },
    stop() {
      if (!useStoreRoot().isEstonianLicense || !this.intervalID) {
        return;
      }

      clearInterval(this.intervalID);
      this.intervalID = null;
      this.setSessionTime();
      window.removeEventListener('beforeunload', this.setSessionTime);
    },
    clear() {
      if (!useStoreRoot().isEstonianLicense) {
        return;
      }

      this.stop();
      this.timeInSecond = 0;
      localStorage.removeItem('session_time');
    },
  },
});
